module.exports = __webpack_public_path__ + "img/Value2.9b82b474.png";